import { render, staticRenderFns } from "./SocsoEdit.vue?vue&type=template&id=9ffed238"
import script from "./SocsoEdit.vue?vue&type=script&lang=js"
export * from "./SocsoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports